var _a;
import { GUI } from 'dat.gui';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
export class GUIBase {
    static get parentGui() {
        if (!this._gui) {
            this._gui = new GUI({
                name: 'Streem SDK GUI',
                hideable: false,
                closed: true,
            });
            if (this._gui.domElement.parentElement) {
                this._gui.domElement.parentElement.style.zIndex = '10000';
            }
            this.hasGUI.next(true);
        }
        return this._gui;
    }
    static createFolder(name) {
        return this.parentGui.addFolder(name);
    }
    static removeGui() {
        if (this._gui) {
            this._gui.destroy();
            this._gui = undefined;
            this.hasGUI.next(false);
        }
    }
}
_a = GUIBase;
GUIBase.hasGUI = new Subject();
GUIBase.onGUIDestroyed = _a.hasGUI.asObservable().pipe(
// Filter to when when hasGUI = false
filter(x => !x));
//# sourceMappingURL=gui_base.js.map